import dayjs from 'dayjs';
import type { ticketDetails } from 'shared';
import type { flightEntity } from 'freedom-shared';

/**
 * Gets current flight time and date for a specific flight index
 */
export function getCurrentFlightTimeAndDate(
  offer:
    | (ticketDetails.types.MappedOffer | flightEntity.types.MappedOffer)
    | undefined,
  flightIndex: number,
): { time: string; date: string } {
  const flight = offer?.flights[flightIndex];
  const dep = flight?.segments[0]?.dep;
  const time = dep?.time || '';
  const date = dep?.at ? dayjs(dep.at).format('YYYY-MM-DD') : '';

  return { time, date };
}
